import { memo } from 'react';
import { Box, Button, CssBaseline, Grid, Stack } from '@mui/material';
import PageMainTitle from 'components/cmn/PageMainTitle';
import ProjectSearch from 'components/project/list/ProjectSearch';
import CustomCard from 'components/cmn/CustomCard';
import ProjectListTable from 'components/project/list/ProjectListTable';
import { useNavigate } from 'react-router-dom';
import useMenu from 'hooks/useMenu';

function ProjectPage(): JSX.Element {
  const navigate = useNavigate();
  const { handleChangeMenu } = useMenu();
  const handleCreateProject = () => {
    navigate('/admin/project/create');
    handleChangeMenu(['create']);
  };
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Grid container>
        <Grid item xs={12} sx={{ mb: 2 }}>
          <PageMainTitle title="프로젝트" />
          <ProjectSearch />
          <CustomCard sx={{ mt: 2 }} content={false} border>
            <ProjectListTable />
          </CustomCard>
          <Stack direction="row" justifyContent="center" alignItems="center" sx={{ display: 'flex', mt: 4 }}>
            <Button variant="outlined" color="primary" onClick={handleCreateProject} sx={{ height: 40 }}>
              프로젝트 생성
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(ProjectPage);
